<template>
   <transition>
      <div class="default">
        <div v-for="item in pageObjectForSlug(this.$route.name)" >
            <vue-markdown> {{ item.text }} </vue-markdown>
            <vue-markdown> {{ item.text2 }} </vue-markdown>
        </div>
      </div>
    </transition>
</template>

<script>
import { PageObject } from './../util/pageobject.js'
import { mapGetters } from 'vuex'
const o = new PageObject()

export default {
  name: 'default',
   data () {
    return {
    //  localStorage: this.$store.state.jsonData
    }
  },
  computed: {
    ...mapGetters({
      localStorage: 'getKirbyData'
    })
  },
  methods:{
    pageObjectForSlug(sulgname){
      let res = o.pageObjectForSlugFromArray(sulgname,this.localStorage)
      return res;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Default.vue